
import { useCallback, useState } from 'react';
import { ConfirmationDialog } from '../ConfirmationDialog';

export const useConfirm = (title, message) => {
    const [promise, setPromise] = useState(null);

    const confirm = useCallback(() => new Promise((resolve, reject) => {
        setPromise({ resolve });
    }), []);

    const handleClose = () => {
        setPromise(null);
    };

    const handleConfirm = () => {
        promise?.resolve(true);
        handleClose();
    };

    const handleCancel = () => {
        promise?.resolve(false);
        handleClose();
    };
    const DialogConfirm = (): JSX.Element => {
        return <>
            <ConfirmationDialog
                onConfirm={handleConfirm}
                onClose={handleCancel}
                open={promise !== null}
                title={title}
                message={message}
            />
        </>
    }
        ;
    return { DialogConfirm, confirm };
};
